import { render, staticRenderFns } from "./FieldsRestrictedManager.vue?vue&type=template&id=2c080471&scoped=true&"
import script from "./FieldsRestrictedManager.vue?vue&type=script&lang=js&"
export * from "./FieldsRestrictedManager.vue?vue&type=script&lang=js&"
import style0 from "./FieldsRestrictedManager.vue?vue&type=style&index=0&id=2c080471&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c080471",
  null
  
)

export default component.exports